import React, { useEffect, useRef } from "react";

const UnderlineSketch = ({ className = "w-full h-2", color = "black", }) => {
  const canvasRef = useRef(null);
  const COLOR_MAP = {
    colorWhite: "#ffffff",
    colorGray: "#9ca3af",      // Tailwind gray-400
    colorDark: "#0e1116",      // dein Hintergrund
    colorAccent: "#ec4899",    // Tailwind pink-500
    colorMuted: "#6b7280",     // Tailwind gray-500
    zenBrand: "#AC8E66",       // Gold Brand Color
    colorOrange: "#fdba74",    // Tailwind orange-300
    colorAmber: "#fbbf24",     // Tailwind amber-400
    colorBlack: "#000000",
  };

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    canvas.width = canvas.offsetWidth;
    canvas.height = canvas.offsetHeight;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.beginPath();
    ctx.moveTo(0, canvas.height / 2);

    // Wellenförmig mit kleinen Asymmetrien
    ctx.bezierCurveTo(
      canvas.width * 0.2,
      canvas.height * 0.6,
      canvas.width * 0.4,
      canvas.height * 0.4,
      canvas.width * 0.6,
      canvas.height * 0.5
    );
    ctx.bezierCurveTo(
      canvas.width * 0.8,
      canvas.height * 0.7,
      canvas.width * 0.95,
      canvas.height * 0.3,
      canvas.width,
      canvas.height / 2
    );

    const resolvedColor = COLOR_MAP[color] || color;
    ctx.strokeStyle = resolvedColor;
    ctx.lineWidth = 1.2;
    ctx.lineCap = "round";
    ctx.setLineDash([6, 0.3]); // ✍🏻 klassisch gezeichnet wirkend
    ctx.stroke();
  }, [color]);

  return <canvas ref={canvasRef} className={className} />;
};

export default UnderlineSketch;
